import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 2em;

    display: flex;
    justify-content: end;
    align-items: center;

    .layout-button {
        .button {
            font-weight: 300 !important;
            text-decoration: underline;
        }
    }
    .title-closed {
        text-align: right;
        width: 100%;
    }

    @media all and (max-width: ${variables.tabletL}) {}
`;